import type { MessageKey } from "./ru"

export const arMessages = {
  "common.loading": "جارٍ التحميل...",
  "common.error": "خطأ",
  "common.back": "رجوع",
  "common.next": "التالي",
  "common.search": "بحث",
  "auth.loginErrorTitle": "خطأ في تسجيل الدخول",
  "auth.openViaTelegram": "افتح التطبيق عبر Telegram",
  "auth.telegramRequired": "يجب فتح التطبيق عبر Telegram",
  "auth.authorizationError": "خطأ في التفويض",
  "device.rotatePortrait": "أدر جهازك إلى الوضع العمودي",
  "country.brazil": "البرازيل",
  "country.vietnam": "فيتنام",
  "country.egypt": "مصر",
  "country.india": "الهند",
  "country.indonesia": "إندونيسيا",
  "country.iran": "إيران",
  "country.spain": "إسبانيا",
  "country.italy": "إيطاليا",
  "country.kazakhstan": "كازاخستان",
  "country.colombia": "كولومبيا",
  "country.malaysia": "ماليزيا",
  "country.mexico": "المكسيك",
  "country.nigeria": "نيجيريا",
  "country.pakistan": "باكستان",
  "country.russia": "روسيا",
  "country.usa": "الولايات المتحدة",
  "country.turkey": "تركيا",
  "country.uzbekistan": "أوزبكستان",
  "country.ukraine": "أوكرانيا",
  "country.philippines": "الفلبين",
  "countrySelection.chooseCountry": "اختر بلدًا",
  "countrySelection.openAria": "اختيار بلد",
  "languageSelection.chooseLanguage": "اختر لغة",
  "commercial.direction.autotrade": "سوق السيارات",
  "commercial.direction.insurance": "التأمين",
  "commercial.direction.pitstop": "مركز الخدمة",
  "commercial.direction.techhelp": "المساعدة على الطريق",
  "commercial.searchLabel": "بحث BeepApp",
  "commercial.cityPlaceholder": "أدخل المدينة",
  "commercial.emptyTitle": "لا توجد عروض اليوم",
  "commercial.emptyLine1": "لا يوجد شركاء BeepApp نشطون في مدينتك حتى الآن",
  "commercial.emptyLine2": "نعمل بالفعل على العثور عليهم وربطهم",
  "commercial.emptyLine3": "ستظهر العروض الجديدة هنا تلقائيًا",
  "commercial.helperLine1": "أدخل مدينتك لعرض",
  "commercial.helperLine2": "العروض المتاحة",
  "commercial.partnerPrompt": "هل تريد أن تصبح شريكًا في BeepApp؟",
  "commercial.apply": "تقديم طلب",
  "main.admin": "الإدارة",
  "main.garage": "المرآب",
  "main.signalSent": "تم إرسال الإشارة",
  "main.partnerInviteUnavailable": "دعوة الشريك غير متاحة",
  "main.enterPlate": "أدخل رقم اللوحة",
  "main.searchError": "خطأ في البحث",
  "main.signalSendError": "تعذر إرسال الإشارة",
  "main.shareCardPrefix": "بطاقة اللوحة",
  "main.shareLinkError": "تعذر إعداد الرابط",
  "main.searchByPlateAria": "البحث برقم اللوحة",
  "main.russianPlateAria": "لوحة تسجيل روسية",
  "main.plateAria": "رقم اللوحة",
  "main.findPlateAria": "العثور على اللوحة",
  "main.loadingVehicle": "جارٍ تحميل بطاقة اللوحة…",
  "main.leaveSignal": "إرسال إشارة",
  "main.share": "مشاركة",
  "signalSelection.chooseType": "اختر نوع الإشارة",
  "signalSelection.category.attention": "شخصية",
  "signalSelection.category.road": "الطريق",
  "signalSelection.category.urgent": "عاجلة",
  "signalSelection.chooseSignal": "اختر إشارة",
  "signalSelection.suggestOwn": "اقترح خيارك",
  "signalConfirmation.title": "تأكيد الإشارة",
  "signalConfirmation.plateHeading": "تحقق من رقم اللوحة",
  "signalConfirmation.signalHeading": "تحقق من الإشارة المحددة",
  "signalConfirmation.replyTitle": "السماح بالرد في Telegram",
  "signalConfirmation.replyBody": "فعّل هذه الوظيفة ليتمكن مالك اللوحة من\nمراسلتك في Telegram. الرد متاح فقط إذا كان لديك\n@username. ويبقى قرار الرد\nلمالك اللوحة.",
  "signalConfirmation.consentText": "أؤكد أن هذه الإشارة تعكس\nموقفًا حقيقيًا وليست رسالة مزعجة\nأو بلاغًا كاذبًا.",
  "signalConfirmation.warning": "بعد الإرسال، لا يمكن\nتغيير الإشارة",
  "signalConfirmation.sending": "جارٍ الإرسال…",
  "signalConfirmation.send": "إرسال",
  "partner.loadingAria": "جارٍ التحميل",
  "partner.title": "برنامج الشركاء",
  "partner.offerLine1": "احصل على 30% من جميع المدفوعات دون حد زمني",
  "partner.offerLine2": "من المستخدمين الذين تدعوهم إلى BeepApp",
  "partner.offerLine3": "عبر برنامج Telegram للشركاء",
  "partner.connectUnavailable": "سيصبح الاتصال متاحًا بعد إعداد برنامج Telegram Affiliate.",
  "partner.connectTelegram": "الاتصال عبر Telegram",
  "partner.qrAria": "رمز QR لرابط الشريك",
  "partner.download": "تنزيل",
  "partner.promoHeading": "أنشئ رمزًا ترويجيًا شخصيًا",
  "partner.promoHelperLine1": "يفعّل الرمز الترويجي سنة إضافية من الاشتراك",
  "partner.promoHelperLine2": "ويساعد على جذب المستخدمين",
  "partner.promoAria": "الرمز الترويجي",
  "partner.affiliateHeading": "رابط الشريك الخاص بك",
  "partner.affiliateHelper": "احفظ الرابط لإنشاء رمز QR شخصي",
  "partner.affiliateAria": "رابط الشريك",
  "partner.qrNoteLine1": "يمكن وضع رمز QR على سيارتك،",
  "partner.qrNoteLine2": "وفي الشبكات الاجتماعية والمواد الإعلانية",
  "partner.save": "حفظ",
  "partner.reset": "إعادة ضبط",
  "partner.resetConfirm": "إعادة ضبط رابط الشريك المحفوظ؟ سيبقى الرمز الترويجي لك.",
  "partner.promoFormatError": "يجب أن يتكون الرمز الترويجي من 4 إلى 15 حرفًا.",
  "partner.affiliateHostError": "يُسمح فقط بروابط t.me أو telegram.me.",
  "partner.affiliatePathError": "لا يحتوي الرابط على مسار Telegram.",
  "partner.affiliateFormatError": "رابط الشريك غير صالح.",
  "partner.loadError": "خطأ في التحميل",
  "partner.checkInputError": "تحقق من البيانات المدخلة",
  "garageActivation.promoInvalid": "الرمز الترويجي غير صالح",
  "garageActivation.plateOccupied": "رقم اللوحة هذا مرتبط بالفعل",
  "garageActivation.activateError": "تعذر تفعيل المرآب",
  "garageEntry.loadJournalError": "تعذر تحميل السجل",
  "garageEntry.loadStatusesError": "تعذر تحميل الحالات",
  "garageEntry.activationSuccess": "تم تفعيل المرآب بنجاح",
  "garageEntry.plateAttached": "تم ربط اللوحة",
  "garageEntry.attachError": "تعذر ربط اللوحة",
  "garageEntry.activationNote": "فعّل المرآب الخاص بك",
  "garageSheet.activationTitle": "تفعيل المرآب",
  "garageSheet.plateHelper": "أدخل رقم لوحة السيارة",
  "garageSheet.promoHelper": "هل لديك رمز ترويجي؟",
  "garageSheet.cleanBonusLine1": "بعد التفعيل، سيكون لديك ساعة واحدة",
  "garageSheet.cleanBonusLine2": "لاستخدام «البداية النظيفة» مجانًا",
  "garageSheet.activationFor": "التفعيل لمدة",
  "garageSheet.cost": "التكلفة",
  "garageSheet.ownerConsentLine1": "أؤكد أنني مالك",
  "garageSheet.ownerConsentLine2": "المركبة التي تحمل",
  "garageSheet.ownerConsentLine3": "رقم اللوحة المحدد.",
  "garageSheet.processing": "جارٍ التنفيذ...",
  "garageSheet.attach": "ربط",
  "garageSheet.pay": "دفع",
  "garageLifecycle.cleanTitle": "البداية النظيفة",
  "garageLifecycle.deactivateTitle": "إلغاء تفعيل المرآب",
  "garageLifecycle.cleanWarningLine1": "سيتم حذف سجل اللوحة",
  "garageLifecycle.cleanWarningLine2": "دون إمكانية الاستعادة!",
  "garageLifecycle.deactivateWarningLine1": "بعد إلغاء التفعيل، سينتهي الوصول إلى",
  "garageLifecycle.deactivateWarningLine2": "ميزات المرآب النشط",
  "garageLifecycle.willBeDeleted": "سيتم الحذف",
  "garageLifecycle.cleanRemovedLine1": "• جميع الإدخالات من سجل الرحلات",
  "garageLifecycle.cleanRemovedLine2": "• سجل الإشارات المستلمة",
  "garageLifecycle.cleanRemovedLine3": "• عدادات الإشارات العامة",
  "garageLifecycle.cleanRemovedLine4": "  في بطاقة اللوحة",
  "garageLifecycle.willRemain": "سيبقى",
  "garageLifecycle.cleanPreservedLine1": "• ربط اللوحة بالمرآب",
  "garageLifecycle.cleanPreservedLine2": "• مدة التفعيل المتبقية",
  "garageLifecycle.cleanPreservedLine3": "• حالة اللوحة المحددة",
  "garageLifecycle.cleanPreservedLine4": "• إجمالي عدد مشاهدات بطاقة اللوحة",
  "garageLifecycle.freeFirstHour": "مجانًا خلال الساعة الأولى",
  "garageLifecycle.willBecomeUnavailable": "سيصبح غير متاح",
  "garageLifecycle.deactivateRemovedLine1": "• سجل الرحلات",
  "garageLifecycle.deactivateRemovedLine2": "• اختيار حالة اللوحة واستخدامها",
  "garageLifecycle.deactivateRemovedLine3": "• ستغادر «AutoClan» تلقائيًا",
  "garageLifecycle.deactivateRemovedLine4": "• سوق السيارات",
  "garageLifecycle.deactivateRemovedLine5": "• التأمين",
  "garageLifecycle.deactivateRemovedLine6": "• مركز الخدمة",
  "garageLifecycle.deactivateRemovedLine7": "• المساعدة على الطريق",
  "garageLifecycle.deactivateRemovedLine8": "• سيتم فصل رقم اللوحة عن المرآب",
  "garageLifecycle.willRemainAvailable": "سيبقى متاحًا",
  "garageLifecycle.deactivatePreservedLine1": "• المرافق",
  "garageLifecycle.deactivatePreservedLine2": "• المرسل",
  "garageLifecycle.deactivatePreservedLine3": "• البحث برقم اللوحة وعرض",
  "garageLifecycle.deactivatePreservedLine4": "  بطاقة السيارة العامة",
  "garageLifecycle.deactivatePreservedLine5": "• إمكانية إعادة تفعيل",
  "garageLifecycle.deactivatePreservedLine6": "  المرآب في أي وقت",
  "garageLifecycle.cleanConsentLine1": "أؤكد موافقتي على حذف",
  "garageLifecycle.cleanConsentLine2": "السجل الكامل لهذه اللوحة",
  "garageLifecycle.cleanConsentLine3": "دون إمكانية الاستعادة.",
  "garageLifecycle.deactivateConsentLine1": "أؤكد إلغاء التفعيل",
  "garageLifecycle.deactivateConsentLine2": "وإنهاء الوصول إلى جميع",
  "garageLifecycle.deactivateConsentLine3": "ميزات المرآب النشط.",
  "garageLifecycle.clean": "مسح",
  "garageLifecycle.deactivate": "إلغاء التفعيل",
} satisfies Record<MessageKey, string>
